/* eslint-disable react/jsx-pascal-case */
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useForm } from 'react-hook-form';
import { useQuery } from 'react-query';
import { listCardsForCurrentLevel } from '../../../../api/card';
import { useClientAuth } from '../../../../providers/ClientProvider';
import { useSnackbar } from '../../../../providers/SnackbarProvider';
import {
  CardAllotmentOrderDto,
  CardIndentationOrderStatus,
  CardStatus,
} from '../../../../types/card';
import { getErrorMessageFromErrorObj } from '../../../../utils/api';
import { CardAllocationService } from '../../../apis';
import CIMS_Modal, {
  IButtonGroupProps,
} from '../../../components/common/CIMS_Modal';
import { useCardIndentationOrder } from '../context';

type ApproveRequestModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  orderData?: CardAllotmentOrderDto;
};

function ApproveRequestModal({
  isOpen,
  handleClose,
  orderData,
}: ApproveRequestModalProps) {
  const hookForm = useForm<{
    numberOfKits: number;
  }>({
    mode: 'all',
  });
  const { clientId, userDivisionId } = useClientAuth();
  const { setSnackbar } = useSnackbar();
  const { listIndentationOrderQuery } = useCardIndentationOrder();

  const listCardQuery = useQuery({
    queryKey: ['listCard_currentLevel', { clientId }],
    queryFn: () => {
      return listCardsForCurrentLevel({
        divisionId: userDivisionId,
        cardStatusList: [CardStatus.IN_STOCK],
        programId: orderData ? [orderData?.programId] : null,
        pageNumber: 0,
        pageSize: 10,
      });
    },
    // select: (data) => {
    //   return data.numberOfItems;
    // },
  });

  const onSubmit = () => {
    const data = hookForm.getValues();
    if (orderData?.id) {
      CardAllocationService.updateCardIndentationOrderStatus({
        cardIndentationOrderId: orderData?.id || '',
        status: CardIndentationOrderStatus.APPROVED,
      })
        .then((res) => {
          setSnackbar('Indentation order approved');
          listIndentationOrderQuery?.refetch();
          hookForm.reset();
        })
        .catch((err) => {
          setSnackbar(
            getErrorMessageFromErrorObj(err, 'Error in aproving the request'),
            'error'
          );
        });
    } else {
      setSnackbar('Indentation Order is not defined ', 'error');
    }
  };

  const buttons: IButtonGroupProps[] = [
    {
      text: 'Approve',
      // disabled: !hookForm.formState.isValid,
      onSubmit: () => {
        onSubmit && onSubmit();
        handleClose();
      },
      icon: '',
      isOutline: false,
    },
  ];
  return (
    <CIMS_Modal
      maxWidth="sm"
      open={isOpen}
      handleClose={handleClose}
      header="Approve Request"
      buttonGroup={buttons}
    >
      <Box sx={{ px: 3, py: 2 }}>
        {/* <Stack spacing={2}>
          <Controller
            name="numberOfKits"
            control={hookForm.control}
            rules={{
              required: 'Required',
              min: 0,
              max:
                listCardQuery.data?.totalItems &&
                orderData?.requestedKits &&
                Math.min(
                  listCardQuery.data?.totalItems,
                  orderData?.requestedKits
                ),
            }}
            render={({ field }) => (
              <EditFormFiled
                title="CARDS TO BE ALLOTED"
                type="number"
                description={field.value ? field.value.toString() : ''}
                onChange={field.onChange}
                placeHolder={'Enter Number of Cards to be allotted'}
              />
            )}
          />
          {listCardQuery.isLoading ? (
            <Skeleton />
          ) : (
            <>
              <Stack direction="row" justifyContent="flex-end" spacing={0.5}>
                <Typography fontSize={13} color="#676B76">
                  {'Requested Kits:'}
                </Typography>
                <Typography fontSize={13} color={'#222222'}>
                  {orderData?.requestedKits}
                </Typography>
              </Stack>
              <Stack direction="row" justifyContent="flex-end" spacing={0.5}>
                <Typography fontSize={13} color="#676B76">
                  {'Available Kits:'}
                </Typography>
                <Typography fontSize={13} color={'#222222'}>
                  {listCardQuery.data?.totalItems}
                </Typography>
              </Stack>
            </>
          )}
        </Stack> */}
        <Typography>Are you sure you want to approve this request?</Typography>
      </Box>
    </CIMS_Modal>
  );
}

export default ApproveRequestModal;
